<template>
  <v-content app>
    <v-container dark>
      <v-row>
        <v-col>
          <h2 class="bc__header">Hi, tell something about yourself and the conference</h2>
        </v-col>
      </v-row>

    </v-container>
  </v-content>
</template>

<script>
export default {
  name: 'BuildConnections'
}
</script>

<style scoped>
  .bc__header {
    font-family: Roboto;
    font-weight: normal;
  }
</style>
